import CHILE_OFFER_FLOW_STEP_IDS from '../../../../../constants/factoring/chile-offer-flow-step-ids';
import SummaryStep from '../../steps/SummaryStep';

export default function buildSummaryStepConfiguration() {
  return {
    id: CHILE_OFFER_FLOW_STEP_IDS.SUMMARY,
    title: 'Resumen de operación',
    component: SummaryStep,
  };
}
